// The frontend icon set. `categories.icon` and `collections.icon` in
// taxonomy.yml are keys into this map.
//
// Emoji rather than an icon font or SVG sprite: no extra asset to load, no
// licence to track, legible at the ~18px a map marker gets on a phone, and it
// keeps taxonomy.yml editable by someone who is not going to draw an icon for
// their new category. An unknown key falls back to the collection's icon and
// then to a neutral pin, so adding a category before choosing an icon is safe.

export const ICONS = {
  // Roads & Traffic
  road: '🛣️', pothole: '🕳️', pavement: '🧱', bollard: '🚧', barrier: '🚧',
  streetlight: '💡', trafficlight: '🚦', crossing: '🚸', sign: '🪧',
  drain: '🕳️', water: '💧', debris: '🪵', spill: '🛢️', ice: '🧊',
  roadworks: '🚧', closure: '⛔', bus: '🚏', ev: '🔌',

  // Waste & Cleanliness
  waste: '🗑️', flytipping: '🛻', binbag: '🗑️', furniture: '🛋️', cardboard: '📦',
  litter: '🥤', bin: '🗑️', graffiti: '🎨', poster: '📄', dog: '🐕',
  needle: '💉', glass: '🔨', animal: '🦊', trolley: '🛒', overgrown: '🌿',

  // Parks, Trees & Green Spaces
  tree: '🌳', fallentree: '🪵', path: '🥾', playground: '🛝', bench: '🪑',
  fence: '🚧', sport: '⚽', bridge: '🌉',

  // Vehicles & Parking
  car: '🚗', parking: '🅿️', bike: '🚲', scooter: '🛴', exhaust: '💨',

  // Weather & Environment
  weather: '🌦️', rain: '🌧️', storm: '⛈️', lightning: '⚡', wind: '💨',
  snow: '❄️', hail: '🌨️', fog: '🌫️', heat: '🌡️', flood: '🌊',
  power: '⚡', gas: '☣️', smoke: '🔥', pollution: '🏭', smell: '👃', light: '🔦',

  // Nuisance & Disturbance
  noise: '🔊', music: '🎵', party: '🎉', construction: '🏗️', fireworks: '🎆',
  alarm: '🚨', drink: '🍺', vandalism: '🔨',

  // Safety & Incidents
  warning: '⚠️', collision: '💥', fire: '🔥', fight: '🥊', crowd: '👥',
  building: '🏚️', scaffold: '🏗️',

  // Community & Events
  event: '📅', festival: '🎪', protest: '📢', parade: '🎺', funfair: '🎡',
  market: '🏪', run: '🏃', film: '🎬',
};

const FALLBACK = '📍';

export function iconFor(key, collectionIcon = null) {
  return ICONS[key] ?? ICONS[collectionIcon] ?? FALLBACK;
}
